import { NgModule } from "@angular/core";
import { AllUserSelectorComponent } from "ng/src/app/templates/all-user-selector/all-user-selector.component";
import { TemplateEditorComponent } from "ng/src/app/templates/editor/template-editor.component";
import { SegmentEditorComponent } from "ng/src/app/templates/segment-editor/segment-editor.component";
import { TemplateCopierComponent } from "ng/src/app/templates/template-copier/template-copier.component";
import { SharedModule } from "ng/src/app/shared/shared.module";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CascadeSelectModule } from "primeng/cascadeselect";
import { DragDropModule } from "primeng/dragdrop";
import { DropdownModule } from "primeng/dropdown";
import { TagsModule } from "ng/src/app/tags/tags.module";
import { ChoiceListModule } from "ng/src/app/choice-lists/choice-list.module";
import { LogModule } from "ng/src/app/logs/log.module";
import { InputTextareaModule } from "primeng/inputtextarea";
import { SelectButtonModule } from "primeng/selectbutton";
import { InputSwitchModule } from "primeng/inputswitch";
import { ButtonModule } from "primeng/button";
import { DividerModule } from "primeng/divider";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { MessageModule } from "primeng/message";
import { TemplateSegmentClipboardComponent } from "ng/src/app/templates/clipboard/template-segment-clipboard.component";
import { SplitButtonModule } from "primeng/splitbutton";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { MenuModule } from "primeng/menu";
import { CardModule } from "primeng/card";
import { CheckboxModule } from "primeng/checkbox";
import { MessagesModule } from "primeng/messages";
import { DialogModule } from "primeng/dialog";
import { TableModule } from "primeng/table";
import { ConfirmPopupModule } from "primeng/confirmpopup";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { NoteRefreshComponent } from "ng/src/app/templates/note-refresh/note-refresh.component";
import { CalendarModule } from "primeng/calendar";
import { AccordionModule } from "primeng/accordion";
import { TemplateListComponent } from "ng/src/app/templates/list/template-list.component";
import { AutoCompleteModule } from "primeng/autocomplete";
import { TemplateSelectorComponent } from "ng/src/app/templates/template-selector.component";
import { TagModule } from "primeng/tag";
import { TemplateDetailComponent } from "ng/src/app/templates/detail/template-detail.component";
import { OrderListModule } from "primeng/orderlist";
import { TabMenuModule } from "primeng/tabmenu";
import { TabViewModule } from "primeng/tabview";
import { InputTextModule } from "primeng/inputtext";
import { InplaceModule } from "primeng/inplace";
import { InputNumberModule } from "primeng/inputnumber";
import { RadioButtonModule } from "primeng/radiobutton";
import { UsersModule } from "ng/src/app/users/users.module";
import { TemplateAlertContainerComponent } from "ng/src/app/templates/upgrade/template-alert-container.component";
import { AlertTriggerEditorComponent } from "ng/src/app/templates/trigger-editor/alert-trigger-editor.component";
import { ReportModule } from "ng/src/app/reports/report.module";
import { AlertTriggersComponent } from "ng/src/app/templates/alert-triggers/alert-triggers.component";
import { TreeModule } from "primeng/tree";
import { TreeSelectModule } from "primeng/treeselect";
import { FormulaEditorComponent } from './formula-editor/formula-editor.component';

@NgModule({
	declarations: [
		TemplateListComponent,
		TemplateCopierComponent,
		TemplateSegmentClipboardComponent,
		NoteRefreshComponent,
		TemplateSelectorComponent,
		TemplateDetailComponent,
		TemplateAlertContainerComponent,
		AlertTriggerEditorComponent,
		AlertTriggersComponent,
		AllUserSelectorComponent,
		TemplateEditorComponent,
		SegmentEditorComponent,
  FormulaEditorComponent
	],
	imports: [
		SharedModule,
		CommonModule,
		FormsModule,
		DropdownModule,
		TagsModule,
		ChoiceListModule,
		LogModule,
		SelectButtonModule,
		InputSwitchModule,
		ButtonModule,
		DividerModule,
		ProgressSpinnerModule,
		MessageModule,
		SplitButtonModule,
		ConfirmDialogModule,
		MenuModule,
		CardModule,
		CheckboxModule,
		MessagesModule,
		DialogModule,
		TableModule,
		ConfirmPopupModule,
		OverlayPanelModule,
		CalendarModule,
		AccordionModule,
		AutoCompleteModule,
		TagModule,
		OrderListModule,
		TabMenuModule,
		TabViewModule,
		InputTextModule,
		InplaceModule,
		InputNumberModule,
		RadioButtonModule,
		UsersModule,
		ReportModule,
		ReactiveFormsModule,
		InputTextareaModule,
		DragDropModule,
		TreeModule,
		CascadeSelectModule,
		TreeSelectModule
	],
	exports: [
		TemplateCopierComponent,
		TemplateSelectorComponent,
		AlertTriggerEditorComponent
	]
})
export class TemplateModule {}